import './footer.css';

const Footer = () => {
    return (
        <footer class="App-footer">
            <a href="/team">Meet the Team</a>
            <span class="separator">|</span>
            <a href="mailto:contact@doubleedge.gg">contact@doubleedge.gg</a>
            <span class="separator">|</span>
            <span>© Double Edge Games, Inc. 2025</span>
        </footer>
    );
};

export default Footer;
